import DialogSelector from '@/components/dialog-selector'
import AdvancedSelector from '@/components/advanced-selector'
import ShopDialogSelector from '@/components/shop-dialog-selector'
import MallitemDialogSelector from '@/components/mallitem-dialog-selector'
import MallitemAdvancedSelector from '@/components/mallitem-advanced-selector'
import EmpAdvancedSelector from '@/components/emp-advanced-selector'
import ShopAdvancedSelector from '@/components/shop-advanced-selector'
import Selector from '@/components/selector'
import Radio from '@/components/radio'
import DatePickerSelector from '@/components/date-picker-selector'
import CheckboxGroup from '@/components/checkbox-group'
import ProductDialogSelector from '@/components/product-dialog-selector'
import EmpDialogSelector from '@/components/emp-dialog-selector'
import MiniprograpSelector from '@/components/miniprogram-selector'
import TagDialogSelector from '@/components/tag-dialog-selector'
import ProductAdvancedSelector from './components/product-advanced-selector'
import ServiceitemAdvancedSelector from './components/serviceitem-advanced-selector'
import ServiceitemDialogSelector from '@/components/serviceitem-dialog-selector'
import DepartmentDialogSelector from '@/components/department-dialog-selector'
import MemberCardDialogSelector from '@/components/membercard-dialog-selector'
import TreatPackDialogSelector from '@/components/treatpack-dialog-selector'
import MockElSelect from '@/components/mock-el-select'
import CategroyEnter from '@/components/xcx-index/components/CategroyEnter.vue'
import FloatImg from '@/components/xcx-index/components/FloatImg.vue'
import goodsClass from '@/components/xcx-index/components/goodsClass.vue'
import groupGood from '@/components/xcx-index/components/groupGood.vue'
import mallItemPerson from '@/components/xcx-index/components/mallItemPerson.vue'
import MultiImg from '@/components/xcx-index/components/MultiImg.vue'
import rushGood from '@/components/xcx-index/components/rushGood.vue'
import SwiperImg from '@/components/xcx-index/components/SwiperImg.vue'
import TextLink from '@/components/xcx-index/components/TextLink.vue'
import Marketing from '@/components/xcx-index/components/Marketing.vue'
import brandDetail from '@/components/xcx-index/components/brandDetail.vue'
import shopDetail from '@/components/xcx-index/components/shopDetail.vue'
import archivesRecommend from '@/components/xcx-index/components/archivesRecommend.vue'
import memberProperty from '@/components/xcx-index/components/memberProperty.vue'
import ModuleEditor from '@/components/module-editor'


const Components = [
	DialogSelector,
	AdvancedSelector,
	ShopAdvancedSelector,
	EmpAdvancedSelector,
	MallitemAdvancedSelector,
	MallitemDialogSelector,
	Radio,
	Selector,
	DatePickerSelector,
	CheckboxGroup,
	ShopDialogSelector,
	ProductDialogSelector,
	ProductAdvancedSelector,
	EmpDialogSelector,
	MiniprograpSelector,
	TagDialogSelector,
	ServiceitemAdvancedSelector,
	ServiceitemDialogSelector,
	DepartmentDialogSelector,
	MemberCardDialogSelector,
	TreatPackDialogSelector,
	MockElSelect,
	CategroyEnter,
    FloatImg,
    goodsClass,
    groupGood,
    mallItemPerson,
    MultiImg,
    rushGood,
    SwiperImg,
    TextLink,
	Marketing,
	brandDetail,
	shopDetail,
	archivesRecommend,
	memberProperty,
]

const install = function(Vue) {
	Components.forEach(component => {
		Vue.component(component.name, component);
	});
}

// 文件引入
if (typeof window !== 'undefined' && window.Vue) {
	install(window.Vue);
}
var SHAIRUI = {
	DialogSelector,
	AdvancedSelector,
	ShopAdvancedSelector,
	EmpAdvancedSelector,
	MallitemAdvancedSelector,
	MallitemDialogSelector,
	Radio,
	Selector,
	DatePickerSelector,
	ShopDialogSelector,
	ProductDialogSelector,
	ProductAdvancedSelector,
	EmpDialogSelector,
	MiniprograpSelector,
	TagDialogSelector,
	ServiceitemAdvancedSelector,
	ServiceitemDialogSelector,
	DepartmentDialogSelector,
	MemberCardDialogSelector,
	TreatPackDialogSelector,
	MockElSelect,
	CategroyEnter,
    FloatImg,
    goodsClass,
    groupGood,
    mallItemPerson,
    MultiImg,
    rushGood,
    SwiperImg,
    TextLink,
	Marketing,
	brandDetail,
	shopDetail,
	archivesRecommend,
	memberProperty,
	ModuleEditor,
	install
}
window.SHAIRUI = SHAIRUI;

export default SHAIRUI;